(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@shraddhar/web/tab-indicator'), require('@shraddhar/web/tab'), require('@shraddhar/web/tab-scroller'), require('@angular/cdk/coercion'), require('@angular/cdk/platform'), require('rxjs'), require('rxjs/operators'), require('@shraddhar/web/base'), require('@material/tab-bar')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/tab-bar', ['exports', '@angular/core', '@shraddhar/web/tab-indicator', '@shraddhar/web/tab', '@shraddhar/web/tab-scroller', '@angular/cdk/coercion', '@angular/cdk/platform', 'rxjs', 'rxjs/operators', '@shraddhar/web/base', '@material/tab-bar'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.tabBar = {}), global.ng.core, global.ng.web.tabIndicator, global.ng.web.tab, global.ng.web.tabScroller, global.ng.cdk.coercion, global.ng.cdk.platform, global.rxjs, global.rxjs.operators, global.ng.web.base, global.mdc.tabBar));
}(this, (function (exports, core, tabIndicator, tab, tabScroller, coercion, platform, rxjs, operators, base, tabBar) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MdcTabActivatedEvent = /** @class */ (function () {
        function MdcTabActivatedEvent(source, index, tab) {
            this.source = source;
            this.index = index;
            this.tab = tab;
        }
        return MdcTabActivatedEvent;
    }());
    var MdcTabBar = /** @class */ (function (_super) {
        __extends(MdcTabBar, _super);
        function MdcTabBar(_platform, _changeDetectorRef, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._platform = _platform;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            _this._destroy = new rxjs.Subject();
            _this._initialized = false;
            _this._fade = false;
            _this._stacked = false;
            _this._fixed = false;
            _this._align = null;
            _this._iconIndicator = null;
            _this._useAutomaticActivation = true;
            _this._activeTabIndex = 0;
            _this._focusOnActivate = true;
            _this.activated = new core.EventEmitter();
            /** Subscription to changes in tabs. */
            _this._changeSubscription = null;
            /** Subscription to interaction events in tabs. */
            _this._tabInteractionSubscription = null;
            return _this;
        }
        Object.defineProperty(MdcTabBar.prototype, "fade", {
            get: function () {
                return this._fade;
            },
            set: function (value) {
                this._fade = coercion.coerceBooleanProperty(value);
                this._syncTabs();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "stacked", {
            get: function () {
                return this._stacked;
            },
            set: function (value) {
                this._stacked = coercion.coerceBooleanProperty(value);
                this._syncTabs();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "fixed", {
            get: function () {
                return this._fixed;
            },
            set: function (value) {
                this._fixed = coercion.coerceBooleanProperty(value);
                this._syncTabs();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "align", {
            get: function () {
                return this._align;
            },
            set: function (value) {
                this._align = value || 'start';
                this._syncTabScroller();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "iconIndicator", {
            get: function () {
                return this._iconIndicator;
            },
            set: function (value) {
                this._iconIndicator = value;
                this._syncTabs();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "useAutomaticActivation", {
            get: function () {
                return this._useAutomaticActivation;
            },
            set: function (value) {
                this._useAutomaticActivation = coercion.coerceBooleanProperty(value);
                this._foundation.setUseAutomaticActivation(this._useAutomaticActivation);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "activeTabIndex", {
            get: function () {
                return this._activeTabIndex;
            },
            set: function (value) {
                if (this.activeTabIndex !== value) {
                    this._activeTabIndex = value;
                    this.activateTab(this.activeTabIndex);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "focusOnActivate", {
            get: function () {
                return this._focusOnActivate;
            },
            set: function (value) {
                this._focusOnActivate = coercion.coerceBooleanProperty(value);
                this._syncTabs();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTabBar.prototype, "tabInteractions", {
            /** Combined stream of all of the tab interaction events. */
            get: function () {
                return rxjs.merge.apply(void 0, __spread(this.tabs.map(function (tab) { return tab.interacted; })));
            },
            enumerable: true,
            configurable: true
        });
        MdcTabBar.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                scrollTo: function (scrollX) { return _this.tabScroller.scrollTo(scrollX); },
                incrementScroll: function (scrollXIncrement) { return _this.tabScroller.incrementScroll(scrollXIncrement); },
                getScrollPosition: function () { return _this.tabScroller.getScrollPosition(); },
                getScrollContentWidth: function () { return _this.tabScroller.getScrollContentWidth(); },
                getOffsetWidth: function () { return _this._getHostElement().offsetWidth; },
                isRTL: function () { return _this._platform.isBrowser ?
                    window.getComputedStyle(_this._getHostElement()).getPropertyValue('direction') === 'rtl' : false; },
                setActiveTab: function (index) { return _this.activateTab(index); },
                activateTabAtIndex: function (index, clientRect) {
                    if (_this._indexIsInRange(index)) {
                        _this.tabs.toArray()[index].activate(clientRect);
                    }
                },
                deactivateTabAtIndex: function (index) {
                    if (_this._indexIsInRange(index)) {
                        _this.tabs.toArray()[index].deactivate();
                    }
                },
                focusTabAtIndex: function (index) { return _this.tabs.toArray()[index].focus(); },
                getTabIndicatorClientRectAtIndex: function (previousActiveIndex) {
                    if (!_this._platform.isBrowser) {
                        return { height: 0, width: 0, bottom: 0, top: 0, left: 0, right: 0 };
                    }
                    if (!_this._indexIsInRange(previousActiveIndex)) {
                        previousActiveIndex = _this.activeTabIndex;
                    }
                    return _this.tabs.toArray()[previousActiveIndex].computeIndicatorClientRect();
                },
                getTabDimensionsAtIndex: function (index) { return _this.tabs.toArray()[index].computeDimensions(); },
                getPreviousActiveTabIndex: function () { return _this.tabs.toArray().findIndex(function (_) { return _.active; }); },
                getFocusedTabIndex: function () {
                    return _this._platform.isBrowser ? _this.tabs.toArray().findIndex(function (tab) {
                        return tab.elementRef.nativeElement === document.activeElement;
                    }) : -1;
                },
                getIndexOfTabById: function (id) { return _this.tabs.toArray().findIndex(function (tab) { return id === tab.id; }); },
                getTabListLength: function () { return _this.tabs.length; },
                notifyTabActivated: function (index) {
                    return _this.activated.emit({ source: _this, index: index, tab: _this.tabs.toArray()[index] });
                }
            };
            return new tabBar.MDCTabBarFoundation(adapter);
        };
        MdcTabBar.prototype.ngOnChanges = function (changes) {
            if (!this._initialized) {
                return;
            }
            if (changes['align']) {
                this._syncTabScroller();
            }
        };
        MdcTabBar.prototype.ngAfterContentInit = function () {
            var _this = this;
            this._initialized = true;
            this._foundation.init();
            // When the list changes, re-subscribe
            this._changeSubscription = this.tabs.changes.pipe(operators.startWith(null)).subscribe(function () {
                Promise.resolve().then(function () {
                    if (_this.tabs.length) {
                        _this._syncTabs();
                        _this._syncTabScroller();
                        _this.activateTab(_this.activeTabIndex);
                        _this._resetTabSubscriptions();
                    }
                });
            });
        };
        MdcTabBar.prototype.ngOnDestroy = function () {
            this._destroy.next();
            this._destroy.complete();
            if (this._changeSubscription) {
                this._changeSubscription.unsubscribe();
            }
            this._dropSubscriptions();
        };
        MdcTabBar.prototype._syncTabs = function () {
            var _this = this;
            if (!this.tabs) {
                return;
            }
            this.tabs.forEach(function (tab) {
                tab.stacked = _this._stacked;
                tab.fixed = _this._fixed;
                tab.tabIndicator.fade = _this._fade;
                tab.tabIndicator.icon = _this._iconIndicator;
                tab.focusOnActivate = _this._focusOnActivate;
            });
        };
        MdcTabBar.prototype._syncTabScroller = function () {
            if (this.tabScroller) {
                this.tabScroller.align = this.align;
            }
        };
        MdcTabBar.prototype._resetTabSubscriptions = function () {
            this._dropSubscriptions();
            this._listenToTabInteraction();
        };
        MdcTabBar.prototype._dropSubscriptions = function () {
            if (this._tabInteractionSubscription) {
                this._tabInteractionSubscription.unsubscribe();
                this._tabInteractionSubscription = null;
            }
        };
        /** Listens to interaction events on each tab. */
        MdcTabBar.prototype._listenToTabInteraction = function () {
            var _this = this;
            this._tabInteractionSubscription = this.tabInteractions.subscribe(function (event) {
                var previousTab = _this.getActiveTab();
                if (previousTab) {
                    previousTab.tabIndicator.active = false;
                }
                event.detail.tab.tabIndicator.active = true;
                _this._foundation.handleTabInteraction(event);
            });
        };
        /** Activates the tab at the given index */
        MdcTabBar.prototype.activateTab = function (index) {
            if (!this.tabs) {
                return;
            }
            this.activeTabIndex = index;
            if (this._platform.isBrowser) {
                this._foundation.activateTab(index);
            }
            this._changeDetectorRef.markForCheck();
        };
        /** Scrolls the tab at the given index into view */
        MdcTabBar.prototype.scrollIntoView = function (index) {
            this._foundation.scrollIntoView(index);
        };
        MdcTabBar.prototype.getActiveTabIndex = function () {
            return this.tabs.toArray().findIndex(function (_) { return _.active; });
        };
        MdcTabBar.prototype.getActiveTab = function () {
            return this.tabs.toArray().find(function (_) { return _.active; });
        };
        /** Returns an index for given tab */
        MdcTabBar.prototype.getTabIndex = function (tab) {
            return this.tabs.toArray().indexOf(tab);
        };
        /** Disable or enable the tab at the given index */
        MdcTabBar.prototype.disableTab = function (index, disabled) {
            if (!this.tabs) {
                return;
            }
            this.tabs.toArray()[index].disabled = coercion.coerceBooleanProperty(disabled);
        };
        MdcTabBar.prototype._onKeydown = function (evt) {
            this._foundation.handleKeyDown(evt);
        };
        MdcTabBar.prototype._indexIsInRange = function (index) {
            return index >= 0 && index < this.tabs.length;
        };
        /** Retrieves the DOM element of the component host. */
        MdcTabBar.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcTabBar.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdcTabBar], mdc-tab-bar',
                        exportAs: 'mdcTabBar',
                        host: {
                            'role': 'tablist',
                            'class': 'mdc-tab-bar',
                            '(keydown)': '_onKeydown($event)'
                        },
                        template: '<ng-content></ng-content>',
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                        providers: [{ provide: tab.MDC_TAB_BAR_PARENT_COMPONENT, useExisting: MdcTabBar }]
                    }] }
        ];
        /** @nocollapse */
        MdcTabBar.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: core.ChangeDetectorRef },
            { type: core.ElementRef }
        ]; };
        MdcTabBar.propDecorators = {
            fade: [{ type: core.Input }],
            stacked: [{ type: core.Input }],
            fixed: [{ type: core.Input }],
            align: [{ type: core.Input }],
            iconIndicator: [{ type: core.Input }],
            useAutomaticActivation: [{ type: core.Input }],
            activeTabIndex: [{ type: core.Input }],
            focusOnActivate: [{ type: core.Input }],
            activated: [{ type: core.Output }],
            tabScroller: [{ type: core.ContentChild, args: [tabScroller.MdcTabScroller, { static: true },] }],
            tabs: [{ type: core.ContentChildren, args: [tab.MdcTab, { descendants: true },] }]
        };
        return MdcTabBar;
    }(base.MDCComponent));

    var MdcTabBarModule = /** @class */ (function () {
        function MdcTabBarModule() {
        }
        MdcTabBarModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [
                            tabIndicator.MdcTabIndicatorModule,
                            tab.MdcTabModule,
                            tabScroller.MdcTabScrollerModule
                        ],
                        exports: [
                            MdcTabBar,
                            tabIndicator.MdcTabIndicatorModule,
                            tab.MdcTabModule,
                            tabScroller.MdcTabScrollerModule
                        ],
                        declarations: [MdcTabBar]
                    },] }
        ];
        return MdcTabBarModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MdcTabActivatedEvent = MdcTabActivatedEvent;
    exports.MdcTabBar = MdcTabBar;
    exports.MdcTabBarModule = MdcTabBarModule;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-tab-bar.umd.js.map
